import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';

const AIProgressModal = ({ isOpen, onClose, logs, isComplete, extractedData }) => {
  return (
    <Dialog open={isOpen} onOpenChange={isComplete ? onClose : undefined}>
      <DialogContent className="max-w-lg" onInteractOutside={(e) => !isComplete && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {isComplete ? (
              <CheckCircle className="h-5 w-5 text-green-600" />
            ) : (
              <Loader2 className="h-5 w-5 animate-spin text-blue-600" />
            )}
            <span>🤖 Extração de Dados com IA</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          {/* Logs de Progresso */}
          <div className="bg-gray-50 rounded-lg p-4 max-h-64 overflow-y-auto font-mono text-sm">
            {logs.map((log, index) => (
              <div
                key={index}
                className={`flex items-start gap-2 mb-2 animate-fade-in ${
                  log.type === 'error' ? 'text-red-600' :
                  log.type === 'success' ? 'text-green-600' :
                  log.type === 'info' ? 'text-blue-600' :
                  'text-gray-700'
                }`}
              >
                <span className="text-base">{log.icon}</span>
                <span className="flex-1">{log.message}</span>
              </div>
            ))}
            
            {!isComplete && (
              <div className="flex items-center gap-2 text-blue-600 animate-pulse">
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>Processando...</span>
              </div>
            )}
          </div>

          {/* Dados Extraídos (quando completo) */}
          {isComplete && extractedData && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <h4 className="font-semibold text-green-800 mb-2">✅ Dados Extraídos:</h4>
              <div className="space-y-1 text-sm">
                {extractedData.customer_name && (
                  <div className="flex gap-2">
                    <span className="font-semibold">👤 Cliente:</span>
                    <span>{extractedData.customer_name}</span>
                  </div>
                )}
                {extractedData.order_number && (
                  <div className="flex gap-2">
                    <span className="font-semibold">📋 Order:</span>
                    <span>#{extractedData.order_number}</span>
                  </div>
                )}
                {extractedData.address && (
                  <div className="flex gap-2">
                    <span className="font-semibold">📍 Endereço:</span>
                    <span>{extractedData.address}</span>
                  </div>
                )}
                {extractedData.city && (
                  <div className="flex gap-2">
                    <span className="font-semibold">🏙️ Cidade:</span>
                    <span>{extractedData.city}</span>
                  </div>
                )}
                {extractedData.zip_code && (
                  <div className="flex gap-2">
                    <span className="font-semibold">📮 ZIP:</span>
                    <span>{extractedData.zip_code}</span>
                  </div>
                )}
                {extractedData.year_built && (
                  <div className="flex gap-2">
                    <span className="font-semibold">🏠 Ano Construção:</span>
                    <span>{extractedData.year_built}</span>
                  </div>
                )}
                {(extractedData.windows !== undefined && extractedData.windows !== null) && (
                  <div className="flex gap-2">
                    <span className="font-semibold">🪟 Janelas:</span>
                    <span>{extractedData.windows}</span>
                  </div>
                )}
                {(extractedData.doors !== undefined && extractedData.doors !== null) && (
                  <div className="flex gap-2">
                    <span className="font-semibold">🚪 Portas:</span>
                    <span>{extractedData.doors}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {isComplete && (
          <DialogFooter>
            <Button onClick={onClose} className="bg-green-600 hover:bg-green-700">
              ✅ OK
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AIProgressModal;
